import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import NetworkAPI from 'api/faber/NetworkAPI'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'
import OrbitSession from 'hooks/useCookies'

let toggledWarningFromPrevLocation = false

interface LocationState {
  reason?: string | undefined
}

export default function WhitelistManagementPage() {
  // reads the redirect error and toasts it to the client
  const location = useLocation()

  const state = location.state as LocationState
  if (state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(state.reason)
    delete state.reason
  }

  const faberToken = OrbitSession.get('faberToken')

  const { data: networkDetails, isFetching } = useQuery(
    ['getNetworkDetailList'],
    async () => NetworkAPI.getAllNetworkDetailData(faberToken)
  )

  const networkData = networkDetails?.data?.data ?? []
  let headers: Array<string> = []

  if (networkData?.length > 0) {
    headers = Object.keys(networkData[0])
  }
  const navigate = useNavigate()

  const onRowClick = (whitelistID: string, version: string, name: string) => {
    navigate(`view-whitelist/${whitelistID}/${version}`, {
      state: { name: name }
    })
  }

  return (
    <PageLayoutV2 header='Manage Whitelists'>
      <ColorBox sx={{ mb: '20px' }}>
        <Box display='flex' justifyContent='flex-end'>
          <LoadingButton
            variant='outlined'
            component='label'
            sx={{ fontSize: '12px', p: 3, background: 'white' }}
            startIcon={<FileUploadIcon />}
            loadingIndicator={<CircularProgress />}
            onClick={() => {
              navigate('../manage-whitelist/upload')
            }}
          >
            Upload Whitelist Script
          </LoadingButton>
        </Box>
        <Box>
          <TableContainer>
            {isFetching ? (
              <CircularProgress />
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    {headers?.map((heading) => (
                      <TableCell key={heading}>
                        {heading.toUpperCase()}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {networkData?.map((netData) => {
                    return (
                      <TableRow
                        key={netData?.whitelistId + netData?.version}
                        onClick={() =>
                          onRowClick(
                            netData?.whitelistId,
                            netData?.version,
                            netData?.name
                          )
                        }
                        sx={{
                          cursor: 'pointer'
                        }}
                      >
                        {headers?.map((heading) => {
                          return (
                            <TableCell key={netData?.whitelistId + heading}>
                              {netData[heading]}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Box>
      </ColorBox>
    </PageLayoutV2>
  )
}
